import { render, staticRenderFns } from "./AddPhoneToBlacklistModal.vue?vue&type=template&id=bd57f132"
import script from "./AddPhoneToBlacklistModal.vue?vue&type=script&lang=js"
export * from "./AddPhoneToBlacklistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports